import { addDays } from 'date-fns';

/** Tattoos need roughly two weeks to heal before the next sitting. */
export const HEALING_MIN_DAYS = 14;

export type SlotBand = { key: '2wk' | '3wk' | '4wk'; weeks: 2 | 3 | 4; slots: string[] };

/**
 * Healing starts from the sitting, so the window anchors on the session date,
 * but never before "now" (the sim clock) for records seeded in the past.
 */
export function healingBaseIso(sessionStartIso: string, clockIso: string): string {
  return new Date(sessionStartIso).getTime() >= new Date(clockIso).getTime()
    ? sessionStartIso
    : clockIso;
}

/** Earliest a rebook may be booked: base + 14 days. */
export function rebookMinIso(sessionStartIso: string, clockIso: string): string {
  return addDays(new Date(healingBaseIso(sessionStartIso, clockIso)), HEALING_MIN_DAYS).toISOString();
}

/**
 * Six suggested slots in three week-bands (a couple each at 2, 3 and 4 weeks).
 * Deterministic from the base date (no Date.now / Math.random): fixed day
 * offsets (all >= 14) and fixed times, two distinct options per band.
 */
export function generateHealingSlots(sessionStartIso: string, clockIso: string): SlotBand[] {
  const base = new Date(healingBaseIso(sessionStartIso, clockIso));
  const defs: Array<{
    key: SlotBand['key'];
    weeks: 2 | 3 | 4;
    pairs: Array<{ offset: number; hour: number }>;
  }> = [
    { key: '2wk', weeks: 2, pairs: [{ offset: 14, hour: 11 }, { offset: 16, hour: 14 }] },
    { key: '3wk', weeks: 3, pairs: [{ offset: 21, hour: 11 }, { offset: 23, hour: 15 }] },
    { key: '4wk', weeks: 4, pairs: [{ offset: 28, hour: 11 }, { offset: 30, hour: 13 }] },
  ];
  return defs.map(({ key, weeks, pairs }) => ({
    key,
    weeks,
    slots: pairs.map(({ offset, hour }) => {
      const day = addDays(base, offset);
      day.setHours(hour, 0, 0, 0);
      return day.toISOString();
    }),
  }));
}
